module.exports = __webpack_public_path__ + "img/cat_icon.4f4b68fc.png";